import React, { useState, useEffect } from "react";
import { Toast } from "react-bootstrap";

const AutoDismissToast = ({ show, message, onClose, delay = 3000 }) => {
  const [toastInfo, setToastInfo] = useState({
    show: false,
    message: "",
  });

  useEffect(() => {
    if (!show) {
      setToastInfo({ show: false, message: "" });
    }
  }, [show]);

  useEffect(() => {
    if (show && message) {
      setToastInfo({ show: true, message });
      const timer = setTimeout(() => {
        setToastInfo({ show: false, message: "" });
        onClose();
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [show, message, delay, onClose]);

  if (!toastInfo.show || !toastInfo.message) return null;

  return (
    <div className="toast-container">
      <Toast
        show={toastInfo.show}
        onClose={() => {
          setToastInfo({ show: false, message: "" });
          onClose();
        }}
        autohide
        delay={delay}
        className="auto-dismiss-toast"
      >
        <Toast.Header closeButton>
          <strong className="me-auto">Ειδοποίηση</strong>
        </Toast.Header>
        <Toast.Body>{toastInfo.message}</Toast.Body>
      </Toast>
    </div>
  );
};

export default AutoDismissToast;
